import { db } from "@/firebase"
import firebase from "firebase";
import DiagnosticServiceServer from "@/services/server/DiagnosticService";
import store from '@/store/index' 

const diagnostic_ref = db.collection("diagnotics")

async function removeHistoricListFromDiagnostic(idDiagnostic) {
    try {
        const doc_diagnostic_ref = await diagnostic_ref.doc(idDiagnostic)

        await doc_diagnostic_ref.update({
            historics: firebase.firestore.FieldValue.delete()
        })
    } catch (error) {
        console.error(error)
    }

    return true;
}
async function removeSolutionListFromDiagnostic(idDiagnostic) {
    try {
        const doc_diagnostic_ref = await diagnostic_ref.doc(idDiagnostic)

        await doc_diagnostic_ref.update({
            solutionList: firebase.firestore.FieldValue.delete()
        })

    } catch (error) {
        console.error(error)
    }

    return true;
}


const createDiagnosticSolution = async (data, idDiagnostic) => {
    delete data.isModified
    let docRef = diagnostic_ref.doc(idDiagnostic);
    const docSnapshot = await docRef.get();
    // Se o documento não existir, cria
    if (!docSnapshot.exists) {
        await docRef.set({ 
            id: idDiagnostic, 
            id_diagnostic: idDiagnostic,
            isDeleted: false
        }, { merge: true });
    }
    
    const solutionsCollection = docRef.collection('solutions');
    
    // Busca o documento do diagnóstico pelo idDiagnostic
    if (data.id) {
        // Referência para a subcoleção 'solutions'
        // Verifica se já existe algum documento na subcoleção 'solutions'
        const solutionsSnapshot = await solutionsCollection.doc(data.id).get();
        if (solutionsSnapshot.exists) {
            // Atualiza documento existente na subcoleção
            delete data.createdAt
            data = { 
                ...data, 
                updatedAt: new Date(),
                updatedBy: store.state.currentUser?.uid,
            };
            try {
                await solutionsCollection.doc(data.id).update(data);
            } catch (error) {
                throw new Error('Failed to update solution detail: ' + error);
            }
            return { diagnosticSolutionId: docRef.id, detailId: data.id };
        }
    } else {
        // Cria novo documento na subcoleção (se não existir, cria a subcoleção automaticamente)
        data = { 
            ...data,
            deletedAt:null,
            isDeleted: false,
            createdAt: new Date(), 
            createdBy: store.state.currentUser?.uid,
        };
        const itemDoc = await solutionsCollection.add(data);
        await solutionsCollection.doc(itemDoc.id).update({ ...data, id: itemDoc.id });
        return { diagnosticSolutionId: docRef.id, detailId: itemDoc.id };
    }
};

async function deleteDiagnosticSolution(idDiagnostic, idSolution) {
    try {
        if(idDiagnostic && idSolution){
            const deleteUpdate = {deletedAt: new Date(), deletedBy: store.state.currentUser?.uid, isDeleted: true}
            await diagnostic_ref.doc(idDiagnostic).collection('solutions').doc(idSolution).update(deleteUpdate);    
        }
        return true;
    } catch (error) {
        throw new Error('deleteDiagnosticSolutionByProjectId Fail! ' + error);
    }
}

async function getDiagnosticSolutionByDiagnosticId(idDiagnostic) {
    let solutionList = [];
    try {
        const docRef = diagnostic_ref.doc(idDiagnostic);
        const solutionsSnapshot = await docRef
            .collection('solutions')
            .where('isDeleted', '==', false)
            .get();
        solutionsSnapshot.forEach(doc => solutionList.push(doc.data()));
        return solutionList;
    } catch (error) {
        console.error(error);
        return [];
    }
}
async function getDiagnosticByProjectId(idProject) {
    let list = [];
    try {
        const docRef = diagnostic_ref.where('id_project', '==', idProject);
        const diagnosticSnapshot = await docRef.get();
        diagnosticSnapshot.forEach(doc => {
            list.push(doc.data())
        })
        // const diagnosticData = diagnosticSnapshot.data();

        return list;
    } catch (error) {
        console.error(error);
        return [];
    }
}

async function getDiagnosticsByLeadAndFranchisee(idLead, idFranchisee) {
    let list = [];
    try {
        const docRef = diagnostic_ref
            .where('id_lead', '==', idLead)
            .where('id_franchisee', '==', idFranchisee);
        const snapshot = await docRef.get();
        snapshot.forEach(doc => list.push(doc.data()));
        return list;
    } catch (error) {
        console.error(error);
        return [];
    }
}
async function getDiagnosticByDiagnosticId(idDiagnostic) {
    try {
        const docRef = diagnostic_ref.doc(idDiagnostic);
        const diagnosticSnapshot = await docRef.get();
        const diagnosticData = diagnosticSnapshot.data();

        return diagnosticData;
    } catch (error) {
        console.error(error);
        return [];
    }
}

async function legacyDiagnosticSolution(diagnostic) {
    try {
        let { id_doc,solutionList, ...dataWithoutSolutions } = diagnostic;
        if (solutionList && solutionList.length > 0) {
            for (const solution of solutionList) {
                await createDiagnosticSolution(solution, id_doc);
            }
        } 
        await removeSolutionListFromDiagnostic(id_doc)
        
        solutionList = await getDiagnosticSolutionByDiagnosticId(id_doc)
        let dataWithSolutions = {...dataWithoutSolutions, solutionList}
        return dataWithSolutions;
    } catch (error) {
        console.error('Error in legacyDiagnosticSolution:', error);
        throw error;
    }
}

async function createDiagnostic(diagnostic) {
    try {
        // Remove campos que não devem ser salvos diretamente
        const { solutionList, historics, historicsToDelete, ...diagnosticData } = diagnostic;
        
        // Adicionar timestamps
        const diagnosticToSave = {
            ...diagnosticData,
            createdAt: new Date(),
            createdBy: store.state.currentUser?.uid,
            lastUpdateAt: new Date().getTime()
        };

        // Se tiver id_doc, usar set com merge, senão criar novo
        if (diagnostic.id_doc) {
            await diagnostic_ref.doc(diagnostic.id_doc).set({
                ...diagnosticToSave,
                id_doc: diagnostic.id_doc,
                id: diagnostic.id_doc
            }, { merge: true });
            return { data: { data: diagnostic.id_doc } };
        } else {
            const docRef = await diagnostic_ref.add(diagnosticToSave);
            await docRef.update({ id_doc: docRef.id, id: docRef.id });
            return { data: { data: docRef.id } };
        }
    } catch (error) {
        console.error('Error creating diagnostic:', error);
        throw error;
    }
}

async function updateDiagnostic(diagnostic) {
    try {
        if (!diagnostic.id_doc) {
            throw new Error('id_doc is required to update diagnostic');
        }

        // Remove campos que não devem ser atualizados diretamente
        const { solutionList, historics, historicsToDelete, id_doc, ...diagnosticData } = diagnostic;
        
        // Adicionar timestamp de atualização
        const updateData = {
            ...diagnosticData,
            updatedAt: new Date(),
            updatedBy: store.state.currentUser?.uid,
            lastUpdateAt: new Date().getTime()
        };

        await diagnostic_ref.doc(id_doc).update(updateData);
        return { data: { data: id_doc } };
    } catch (error) {
        console.error('Error updating diagnostic:', error);
        throw error;
    }
}

export default { 
    removeHistoricListFromDiagnostic, 
    createDiagnosticSolution, 
    deleteDiagnosticSolution, 
    legacyDiagnosticSolution, 
    getDiagnosticSolutionByDiagnosticId,
    getDiagnosticByDiagnosticId,
    getDiagnosticByProjectId,
    getDiagnosticsByLeadAndFranchisee,
    create: createDiagnostic,
    update: updateDiagnostic
}


